
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" v-on="$listeners" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 8a1 1 0 011-1h12a1 1 0 110 2H2a1 1 0 01-1-1z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1a1 1 0 011 1v12a1 1 0 11-2 0V2a1 1 0 011-1z"></path>
    </svg>
  </template>
  <script>
    export default {
      name: "IconAdd",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    };
  </script>
